const rankingData = [
  {
    rank: 1,
    title: '顶流明星深夜密会神秘女子',
    tag: '明星八卦',
    heat: '🔥 28.6万热度',
    desc: '独家画面曝光，某顶流明星深夜现身某高档酒店，同行神秘女子身份引发全网猜测。',
  },
  {
    rank: 2,
    title: '热门综艺导演组内部矛盾爆发',
    tag: '综艺热点',
    heat: '🔥 23.1万热度',
    desc: '知名综艺节目录制现场导演与嘉宾爆发激烈争执，节目未来走向成谜。',
  },
  {
    rank: 3,
    title: '千万粉丝网红带货翻车现场',
    tag: '网红动态',
    heat: '🔥 19.7万热度',
    desc: '头部网红直播间带货出现重大失误，产品效果与宣传严重不符，粉丝集体维权。',
  },
  {
    rank: 4,
    title: '年度最受争议电影评分出炉',
    tag: '影视话题',
    heat: '⚡ 16.3万热度',
    desc: '备受瞩目的年度大制作电影上映后口碑两极分化，专业评分与观众评分差距悬殊。',
  },
  {
    rank: 5,
    title: '短视频平台头部创作者迁移潮',
    tag: '平台动态',
    heat: '⚡ 14.5万热度',
    desc: '多位千万级粉丝创作者宣布转战新平台，短视频行业格局面临重大洗牌。',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热度榜单</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            实时更新全网最热话题榜单，看看大家都在关注什么
          </p>
        </div>

        <div className="space-y-3">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-start gap-4 bg-background-50 border border-background-300/30 rounded-xl p-4 md:p-5 transition-all hover:border-primary-500/20 cursor-pointer"
            >
              {/* Rank number */}
              <div className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center font-heading font-bold text-lg ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-accent-400 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0">
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 flex-wrap">
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900">
                    {item.title}
                  </h3>
                  <span className="text-xs bg-primary-500/10 text-primary-400 px-2 py-0.5 rounded-md font-medium whitespace-nowrap w-fit">
                    {item.tag}
                  </span>
                </div>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
                <p className="mt-2 text-xs text-foreground-500">{item.heat}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}